import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import Package from './pages/Package';
import Main from './pages/Main';
// import Speaker from './pages/Speaker';
// import Gallery from './pages/Gallery';
// import About from './pages/About';
import Program from './pages/Program';
// import Register from './pages/Register';
// import Participation from './pages/Participation';
import { lazy, Suspense } from 'react';
import GSSC from './pages/GSSC';
import Session from './pages/Session';
import RobotsRoute from './RobotRoute';

const Video = lazy(() => import('./pages/Video'));
const Gallery = lazy(() => import('./pages/Gallery'));
const About = lazy(() => import('./pages/About'));
const Venue = lazy(() => import('./pages/Venue'));
const Speaker = lazy(() => import('./pages/Speaker'));
const KeySpeakers = lazy(() => import('./pages/KeySpeakers'));
// const Program = lazy(() => import('./pages/Program'));
const Register = lazy(() => import('./pages/Register'));
const RegisterCompany = lazy(() => import('./pages/RegisterCompany'));
const Information = lazy(() => import('./pages/Information'));
const Mypage = lazy(() => import('./pages/Mypage'));
const Package = lazy(() => import('./pages/Package'));

const Router = () => {
	return (
		<BrowserRouter>
			<Suspense fallback={'Loading'}>
				<Routes>
					<Route path="/robots.txt" element={<RobotsRoute />} />
					<Route path="/" element={<Main lang={'ko'} bg={'light'} />} />
					<Route path="/en" element={<Main lang={'en'} bg={'light'} />} />
					<Route path="/about" element={<About lang={'ko'} bg={'light'} />} />
					<Route path="/en/about" element={<About lang={'en'} bg={'light'} />} />
					<Route path="/venue" element={<Venue lang={'ko'} bg={'light'} />} />
					<Route path="/en/venue" element={<Venue lang={'en'} bg={'light'} />} />
					<Route path="/information" element={<Information lang={'ko'} bg={'light'} />} />
					<Route path="/en/information" element={<Information lang={'en'} bg={'light'} />} />
					<Route path="/register" element={<Register lang={'ko'} bg={'light'} />} />
					<Route path="/en/register" element={<Register lang={'en'} bg={'light'} />} />
					<Route path="/register-company" element={<RegisterCompany lang={'ko'} bg={'light'} />} />
					<Route path="/mypage" element={<Mypage lang={'ko'} bg={'light'} />} />
					<Route path="/en/mypage" element={<Mypage lang={'en'} bg={'light'} />} />
					<Route path="/key-speakers" element={<KeySpeakers lang={'ko'} bg={'light'} />} />
					<Route path="/en/key-speakers" element={<KeySpeakers lang={'en'} bg={'light'} />} />
					<Route path="/speaker" element={<Speaker lang={'ko'} bg={'light'} />} />
					<Route path="/en/speaker" element={<Speaker lang={'en'} bg={'light'} />} />
					<Route path="/gallery" element={<Gallery lang={'ko'} bg={'light'} />} />
					<Route path="/en/gallery" element={<Gallery lang={'en'} bg={'light'} />} />
					<Route path="/video" element={<Video lang={'ko'} bg={'light'} />} />
					<Route path="/en/video" element={<Video lang={'en'} bg={'light'} />} />
					<Route path="/program" element={<Program lang={'ko'} bg={'dark'} />} />
					<Route path="/en/program" element={<Program lang={'en'} bg={'dark'} />} />
					<Route path="/session" element={<Session lang={'ko'} bg={'dark'} />} />
					<Route path="/en/session" element={<Session lang={'en'} bg={'dark'} />} />
					<Route path="/en/package" element={<Package lang={'en'} bg={'light'} />} />
					<Route path="/gssc" element={<GSSC lang={'en'} bg={'light'} />} />
				</Routes>
			</Suspense>
		</BrowserRouter>
	);
};

export default Router;
